import api from './api';

export const completeOnboarding = async () => {
  const response = await api.post('/auth/complete-onboarding');
  return response.data;
};

export const skipOnboarding = async () => {
  const response = await api.post('/auth/skip-onboarding');
  return response.data;
};
